import { CheckinCard } from '../journal/JournalCard';
import { HelperBeeCard } from '../helper-bee/HelperBeeCard';
import { ResourcesCard } from '../resources/ResourcesCard';
import { TipCard } from './TipCard';
import { GetHelpCard } from '../get-help/GetHelpCard';

export const CaregiverTools: React.FC = () => {
    return (
        <>
            <CheckinCard />
            <HelperBeeCard />
            <GetHelpCard />
            <ResourcesCard />
            <TipCard />
        </>
    );
};
